import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchAvailableServiceTimesDone = (_, { payload }) => {
  return [
    ...payload
  ];
}

const clearAvailableServiceTimesDone = () => {
  return []
}

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_AVAILABLE_SERVICE_TIMES_DONE]: fetchAvailableServiceTimesDone,
  [TYPES.CLEAR_AVAILABLE_SERVICE_TIMES]:clearAvailableServiceTimesDone
});
